// extracted by mini-css-extract-plugin
module.exports = {"ResizeablePanelHandle":"ResizeablePanelHandle_ResizeablePanelHandle__C_Ubu"};